// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__UERul","wrapper":"Loading_wrapper__qedfP","spin":"Loading_spin__oI-6h"};